import { RentalServiceDeliveryChannel } from './../../../models/enums/Payments/PaymnetsEnum';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from './../../../services/loading.service';
import { element } from 'protractor';


import { AuthService } from './../../../services/auth.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OnlineAccountValidation } from 'src/app/models/enums/Auth/OnlineAccountValidationEnum';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { NationalitieModel } from 'src/app/models/Profile/NationalitieModel';


@Component({
  selector: 'register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {


  faTimesCircle = faTimesCircle;
  registerForm: FormGroup;
  hide;
  isSubmitted = false;
  emailOldVal = '';
  nationalities: NationalitieModel;

  passwordPattern = '^(?=.*[0-9])(?=.*[!@#$%^&*])[0-9a-zA-Z!@#$%^&*0-9]{8,}$';
  constructor(private loadingService: LoadingService, private authService: AuthService, private router: Router, private formBuilder: FormBuilder, private translate: TranslateService) { }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      secondName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)])],
      password: ['', Validators.required],
      acceptTerms: [false, Validators.requiredTrue],
      hiddenValidation: [''],
      nationalityID: [null, Validators.required]
    });


    this.authService.getNationalities().subscribe(res => {

      this.nationalities = res;
    })
  }

  get formControls() { return this.registerForm.controls; }


  onSubmit() {
    this.registerForm.controls['hiddenValidation']?.setErrors(null);
    this.isSubmitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    //
    setTimeout(() => {
      this.loadingService.updateLoadingState(true);
    });
    let model = this.registerForm.value;
    model.RentalServiceDeliveryChannelID = RentalServiceDeliveryChannel.Online;


    this.authService.signUp(model).subscribe(res => {
      this.loadingService.updateLoadingState(false);
      if (res) {
        this.router.navigateByUrl('/home');
      }
      else {
        //TODO: Maybe message on the UI
        return;
      }
    }, err => {
      this.loadingService.updateLoadingState(false);

      if (err.status == 422 && err.error.isServerValidation) {
        const validationCode = err.error.code;
        //Todo: Get the msgs from a source.
        switch (validationCode) {

          case OnlineAccountValidation.UnsupportedCustomerType://Invalid Cred
            this.translate.get('UnsupportedCustomerType').subscribe(res => {
              this.registerForm.controls['hiddenValidation']?.setErrors({ 'Default': 'This customer can not be registered , for more information please contact with the administration ' });
            })
            break;
        }


      }
      else {//SHow soemthing went wrong msg
        this.translate.get('SomethingWentWrong').subscribe(res => {
          this.registerForm.controls['hiddenValidation']?.setErrors({ 'Default': res });
        })

      }
    });
    // display form values on success
    //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value, null, 4));
  }

  onReset() {
    this.isSubmitted = false;
    this.registerForm.reset();
  }
  emilBlur(event) {

    let val = event.target.value
    if (val != null && val != "") {
      val = (val as string).trim();
      let errors = this.registerForm.controls['email'].errors;
      if (errors == null) {

        this.emailOldVal = val;
        this.authService.checkIfEmailExist(val).subscribe(res => {
          if (res) {
            this.translate.get('EmailAlreadyExist').subscribe(res => {
              this.registerForm.controls['email']?.setErrors({ 'exist': res });
            })
          }
          else {
            this.registerForm.controls['email']?.setErrors(null);
          }
        })

      }
    }

  }




  a() {

  }


}
